'use client'

// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useHasMounted } from '@/lib/hooks';
import { usePersonalizedResource } from '@/lib/hooks/usePersonalizedResource';
import { myListShows } from '@/lib/resources/my-list-shows';

// components
import LinkButton from '@/components/Button/LinkButton';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import MyListShowPosterGrid from '@/components/MyList/MyListShows/MyListShowPosterGrid';
import SignInButton from '@/components/Navigation/SignInButton';

// styles
import styles from './MyListShows.module.scss';

interface MyListShowsProps {
  showMyStationBadge?: boolean;
}

const MyListShows = ({ showMyStationBadge }: MyListShowsProps) => {
  const shows = usePersonalizedResource(myListShows);
  const hasMounted = useHasMounted();

  if (!hasMounted) return null;

  let content = null;

  switch (shows.status) {
    case 'ready':
      content = <MyListShowPosterGrid shows={shows.items} showMyStationBadge={showMyStationBadge} />;
      break;
    case 'loading':
      content = <LoadingSpinner text="Loading Your List..." />;
      break;
    case 'idle':
    case 'empty':
    case 'error':
      content = (
        <div className={styles.my_list_shows_user_prompt}>
          <h2>Shows you add to My List will appear here.</h2>
          <LinkButton href="/shows/">
            Browse PBS Shows
          </LinkButton>
        </div>
      );
      break;
    case 'needsSignIn':
      content = (
        <div className={styles.my_list_shows_user_prompt}>
          <h2>Sign in to add shows to My List</h2>
          <SignInButton>
            Sign In to Access
          </SignInButton>
        </div>
      );
      break;
  }

  return (
    <div className={styles.my_list_shows} data-sentry-component="MyListShows" data-sentry-source-file="MyListShows.tsx">
     {content}
    </div>
  );
};

export default MyListShows;
